module.exports = __webpack_public_path__ + "img/trip-hour-operation.17f6a37a.svg";